import { render, staticRenderFns } from "./WithdrawFooter.vue?vue&type=template&id=03bca9ac"
import script from "./WithdrawFooter.vue?vue&type=script&lang=js"
export * from "./WithdrawFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports